<script setup lang="ts">
import { Applicant } from '@/application/shared/domain/Applicant';
import QuestionSuffix from '@/application/shared/infrastructure/components/questions/QuestionSuffix.vue';
import { Field } from 'vee-validate';
import { ref } from 'vue';

const props = withDefaults(defineProps<{
  value?: Partial<Applicant>,
  namePrefix?: string,
  hideSuffix?: boolean,
  autoFocus?: boolean
}>(), {
  namePrefix: '',
});

interface EmitInterface {
  (event: 'update:value', value: Partial<Applicant>): void
}

const emits = defineEmits<EmitInterface>();

const emitChange = (): void => {
  emits('update:value', {
    first_name: firstName.value,
    last_name: lastName.value,
    middle_name: middleName.value,
    suffix: suffix.value
  });
};

const firstName = ref(props.value?.first_name);

const lastName = ref(props.value?.last_name);

const middleName = ref(props.value?.middle_name);

const suffix = ref(props.value?.suffix);

</script>
<template>
  <div class="form-inline mb-2">
    <div>
      <Field v-model="firstName" type="text" v-slot="{ field, errorMessage, meta }" :name="`${namePrefix}firstName`" @change="emitChange" rules="required|alpha_spaces_hyphens|max:15">
        <input placeholder="First Name" v-autofocus="autoFocus" v-capitalized="field" v-bind="field" :class="{ ...meta }" class="left">
        <span class="error">{{ errorMessage }}</span>
      </Field>
    </div>
    <div>
      <Field v-model="middleName" type="text" v-slot="{ field, errorMessage, meta }" :name="`${namePrefix}middleName`" @change="emitChange" rules="alpha_spaces_hyphens|max:15">
        <input placeholder="Middle Name" v-capitalized="field" v-bind="field" :class="{ ...meta }" class="middle">
        <span class="error">{{ errorMessage }}</span>
      </Field>
    </div>
    <div>
      <Field v-model="lastName" type="text" v-slot="{ field, errorMessage, meta }" :name="`${namePrefix}lastName`" @change="emitChange" rules="required|alpha_spaces_hyphens|max:15">
        <input placeholder="Last Name" v-capitalized="field" v-bind="field" :class="{ ...meta, ...{'middle': !hideSuffix, 'right': hideSuffix} }">
        <span class="error">{{ errorMessage }}</span>
      </Field>
    </div>
    <div class="md:w-32 flex flex-col" v-if="!hideSuffix">
      <QuestionSuffix v-model="suffix" @update:model-value="emitChange" class="right" />
      <span class="error"></span>
    </div>
  </div>
</template>
